// src/api/sendNotifications.js
// Calls the PHP notifications endpoint after successful application submission.
// Runs in background — does not block the success screen.

const NOTIFICATIONS_URL = "https://hr-hiring-form.fusionlogics.com/notifications.php";

export async function sendNotifications(formData, applicationId) {
  try {
    const payload = {
      first_name:     formData.first_name,
      last_name:      formData.last_name,
      email:          formData.email,
      phone:          formData.phone,
      branch_name:    formData.branch_name,
      job_title:      formData.job_title || formData.position_name || '',
      application_id: applicationId || '',
      resume_link:    formData.resume_link || '',
    };

    const res = await fetch(NOTIFICATIONS_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });

    const result = await res.json();
    return result;

  } catch (err) {
    // Silent fail — notifications never block the user
  }
}